"use client"

import * as React from "react"
import {
  ThemeProvider as ColorSchemeProvider,
  useTheme,
  type ColorScheme,
} from "@exxatdesignux/ui/hooks/use-color-scheme"

import { isEditableTarget } from "@/lib/editable-target"

function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof ColorSchemeProvider>) {
  return (
    <ColorSchemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      <ThemeHotkey />
      {children}
    </ColorSchemeProvider>
  )
}

const THEME_CYCLE: ColorScheme[] = ["light", "dark", "system"]

function ThemeHotkey() {
  const { theme, setTheme } = useTheme()

  React.useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.defaultPrevented || event.repeat) {
        return
      }

      const modifier = event.metaKey || event.ctrlKey
      if (!modifier || !event.altKey || event.shiftKey) {
        return
      }

      if (event.key.toLowerCase() !== "d" && event.code !== "KeyD") {
        return
      }

      if (isEditableTarget(event.target)) {
        return
      }

      event.preventDefault()

      const current = THEME_CYCLE.indexOf((theme ?? "system") as ColorScheme)
      setTheme(THEME_CYCLE[(current + 1) % THEME_CYCLE.length])
    }

    window.addEventListener("keydown", onKeyDown)

    return () => {
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [theme, setTheme])

  return null
}

export { ThemeProvider }
